import './css/App.css';
import './css/Banner.css';
import './css/Responsive.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './routes/NavBar';
import Footer from './components/Footer';
import NavBarMbl from './routes/NavBarMbl';
import StickyModalButton from './components/StickyModalButton';

function App() {
  return (
    <div>
      <NavBar />
      <NavBarMbl />
      <StickyModalButton />
      <Footer />
    </div>
  );
}

export default App;
